export default __webpack_public_path__ + "static/media/sc.7649b871.svg";